import Loading from 'components/organisms/loading';
import ModalError from 'components/molecules/modal/Error';
import React from 'react';
import Loadable from 'react-loadable';
import { useEffect } from 'react';
import { localStorage as localStorageConstants } from 'constants/index';
import * as checkUrl from 'utils/checkUrl';
import { getDefaultNotSetJpConversationLevel, isAppleNameEmptyCheck, isGoogleFirstLogin, } from './snsFlag';
const LoadingComponent = (props) => {
    useEffect(() => {
        getDefaultNotSetJpConversationLevel() ===
            localStorageConstants.DEFAULT_NOT_SET_JAPANESE_CONVERSACTION_LEVEL_VALUE &&
            !checkUrl.isStudentEditInfo() &&
            window.location.replace('/students/profile/edit/info');
        isAppleNameEmptyCheck() &&
            !checkUrl.isTeacherEditName() &&
            window.location.replace('/teachers/profile/edit/name');
        isGoogleFirstLogin() &&
            !checkUrl.isTeacherEditPicture() &&
            window.location.replace('/teachers/profile/edit/picture');
    }, []);
    if (props.error || props.timedOut) {
        return React.createElement(ModalError, { message: "Taking a long time..." });
    }
    else {
        return React.createElement(Loading, { showAnyway: true });
    }
};
export default (component) => {
    return Loadable({
        loader: component,
        loading: LoadingComponent,
        timeout: 60 * 1000, // 60 seconds
    });
};
